export default "__VITE_ASSET__ba8fdbed__"